import type { AvailabilityContext } from '@/app/contract';
export const record = (value: unknown): value is Record<string, unknown> => !!value && typeof value === 'object' && !Array.isArray(value);
export function isAvailable({ flags, config }: AvailabilityContext): boolean {
  return flags['community.ui'] !== false && record(config?.community_context) && config.community_context.enabled === true;
}
export function isId(value: unknown): value is string {
  return typeof value === 'string' && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(value);
}
